
// ListarApagar.js

import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LastPageIcon from '@mui/icons-material/LastPage';
//import Axios from 'axios';
import api from '../config/axiosConfig';


const ListarApagar = ({ handleSairListarClick, onIdClick }) => {
  const [apagarDaPagina, setApagarDaPagina] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [orderBy, setOrderBy] = useState('codcompra'); // Estado para armazenar a ordenação selecionada
  const [filtroCodCompra, setFiltroCodCompra] = useState(''); // Estado para o código de compra
  const [isFiltrando, setIsFiltrando] = useState(false); // Controle para o filtro

  useEffect(() => {
    fetchApagar(currentPage, orderBy);
  }, [currentPage, orderBy]);

  const fetchApagar = async (page, order = 'codcompra') => {
    try {
      console.log(`Solicitando Apagar da página ${page} ordenados por ${order}...`);
      const response = await api.get(`/apagar/listarapagar/paginados?page=${page - 1}&size=10&sortBy=${order}`);
      
      setApagarDaPagina(response.data.content);
      setTotalPages(response.data.totalPages);
      console.log(`Apagar da página ${page} ordenados por ${order} carregados com sucesso:`, response.data.content);
    } catch (error) {
      console.error('Erro ao carregar Apagar:', error);
    }
  };

  const buscarPorCodCompra = async () => {
    try {
      if (filtroCodCompra.trim() === '') {
        alert('Por favor, insira um código de compra válido.');
        return;
      }
      console.log(`Buscando parcelas com código de compra: ${filtroCodCompra}`);
      const response = await api.get(`/apagar/${filtroCodCompra}/parcelas`);

      if (response.data && response.data.length > 0) {
        setApagarDaPagina(response.data);
        setIsFiltrando(true);
        setTotalPages(1); // Ajustar para evitar paginação em busca
      } else {
        alert(`Nenhuma Parcela a Pagar para Compra: ${filtroCodCompra}`);
        setApagarDaPagina([]); // Limpar a tabela
        setIsFiltrando(false); // Desativa o estado de filtragem
      }
    } catch (error) {
      console.error('Erro ao buscar por código de compra:', error);
      setIsFiltrando(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const handleOrderByVencimento = () => {
    setOrderBy('dtvencimento');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  const handleOrderByCodcompra = () => {
    setOrderBy('codcompra');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  const handleOrderByFornecedor = () => {
    setOrderBy('nomefor'); // Mudar para ordenar por nome do fornecedor
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  
  // Função para formatar a data no formato "DD-MM-YYYY"
  const formatarData = (data) => {
  if (!data) return "Data não disponível";
  const partes = data.split('-');
  if (partes.length !== 3) return "Data inválida";
  const [ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
  };


  // Função para formatar valores monetários
  const formatarValor = (valor) => {
    return valor ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor) : 'R$ 0,00';
  };


  return (
    <div>
      <Typography variant="h5" gutterBottom>Listagem de Contas a Pagar</Typography>


      <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
        <Typography variant="body1" style={{ marginTop: '0px', marginLeft: '20px' }}>
          Página {currentPage} de {totalPages}
        </Typography>

       {/* Botões de Navegação */}
        {!isFiltrando && (
          <Box>
            <ButtonGroup variant="contained" color="primary" style={{ height: '25px', padding: '0px 0px', marginLeft: '20px' }}>
              <Button onClick={handleFirstPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<FirstPageIcon />}></Button>
              <Button onClick={handlePreviousPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<NavigateBeforeIcon />}></Button>
              <Button onClick={handleNextPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<NavigateNextIcon />}></Button>
              <Button onClick={handleLastPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<LastPageIcon />}></Button>
            </ButtonGroup>
          </Box>
        )}

      </Box>

<Box display="flex" justifyContent="center" alignItems="center" mt={0}>
  {/* Botões de Ordenação e Busca */}
  <Box display="flex" justifyContent="center" alignItems="center" gap={2}>

    {/* Botões de Ordenação */}
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByCodcompra}
    >
      Lista Por Compra
    </Button>
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByFornecedor}
    >
      Por Fornecedor
    </Button>
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByVencimento}
    >
      Por Vencimento
    </Button>
          
    {/* Campo de Busca */}
    <input
      type="text"
      placeholder="Código Compra"
      value={filtroCodCompra}
      onChange={(e) => setFiltroCodCompra(e.target.value)}
      style={{
        padding: '5px',
        width: '100px',
        marginLeft: '30px',
        height: '25px',
        fontSize: '14px'
      }}
    />
    <Button
      variant="contained"
      color="primary"
      onClick={buscarPorCodCompra}
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
    >
      Buscar
    </Button>          
          
    {/* Botão de Fechar à Direita */}
     <button
        type="button"
        className="btn-menu"
        onClick={handleSairListarClick}
        style={{ fontSize: '12px', fontWeight: 'bold', 
          height: '25px', padding: '3px 6px', marginLeft: '30px', width: '80px', color: 'inherit' }}
      >
        Fechar
      </button>
        
        </Box>
      </Box>

    <div style={{ overflowX: 'auto', margin: '20px' }}>
      <table style={{ textAlign: 'left', borderCollapse: 'collapse', width: '100%', minWidth: '800px' }}>
          
        <thead>
          <tr>
            <th style={{ padding: '10px', width: '80px' }}>Compra</th>
            <th style={{ padding: '10px', width: '150px' }}>Dt Compra</th>
            <th style={{ padding: '10px', width: '250px' }}>Fornecedor</th>
            <th style={{ padding: '10px', width: '80px' }}>Parcela</th>
            <th style={{ padding: '10px', width: '150px' }}>Val Parcela</th>
            <th style={{ padding: '10px', width: '150px' }}>Vencimento</th>
            <th style={{ padding: '10px', width: '150px' }}>Pagamento</th>
          </tr>
        </thead>
        <tbody>
          {apagarDaPagina.map((apagar) => (
            <tr key={apagar.id}>
              
              <td style={{ padding: '10px', cursor: 'pointer', color: 'blue' }}
                onClick={() => onIdClick(apagar.id)}>{apagar.codcompra}</td>              
              <td style={{ padding: '10px' }}>{formatarData(apagar.dtcompra)}</td>
              <td style={{ padding: '10px' }} className="truncate" title={apagar.nomefor}
                translate="no">{apagar.nomefor}</td> {/* Exibe o nome do fornecedor */}
              <td style={{ padding: '10px' }}>{apagar.parcela}</td>
              <td style={{ padding: '10px' }}>{formatarValor(apagar.valparcela)}</td>
              <td style={{ padding: '10px' }}>{formatarData(apagar.dtvencimento)}</td>
              <td style={{ padding: '10px' }}>{formatarData(apagar.dtpagamento)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
      
  </div>
    
  );
};

export default ListarApagar;
